module.exports = __webpack_public_path__ + "static/media/li.5b91a44b.svg";